import { defineComponent, isVNode, toValue } from 'vue'
import { createVNode, render, reactive, h } from 'vue'
import Auth from './index.vue'

export function createAuthDialog(
  props: any = {},
  target: HTMLElement = document.body,
  wait = false
) {
  let vm: any = null
  const data = reactive({
    ...props
  })
  const slot: any = {}
  if (Reflect.has(props, 'slots') && props.slots) {
    const VNodes = Object.entries(props.slots).filter(([_, node]) => isVNode(toValue(node)))
    VNodes.forEach(([key, node]) => {
      slot[key] = node
    })
  }
  const AuthWrap = defineComponent({
    render() {
      return h(Auth, { ...data }, slot)
    }
  })
  vm = createVNode(AuthWrap)
  const div: HTMLDivElement = document.createElement('div')
  if (wait) {
    setTimeout(() => {
      render(vm, div)
    }, 0)
  } else {
    render(vm, div)
  }

  function close() {
    if (div && div.parentNode) {
      div.parentNode.removeChild(div)
    }
  }
  function open(props?: any) {
    if (!vm || !vm.el) {
      return
    }
    setData(props)
    target.appendChild(div)
  }
  function setData(props: any) {
    Object.assign(data, props)
  }
  // if (target) {
  //   open(target)
  // }
  return {
    vm,
    close,
    open,
    setData
  }
}
